import React, { useEffect } from 'react'
import _ from 'underscore'
import styled from 'styled-components'

import { Panel } from 'components/Panel'
import { NoData } from 'styles/shared'
import ConnectedStatusIcon from 'pages/shared/ConnectedStatusIcon'
import LastUpdated from 'pages/Device/LastUpdated'

import Status from './Status'
import ThermostatBox from './ThermostatBox'
import ZoneBox from './ZoneBox'

import useNexiaStream from 'hooks/useNexiaStream'

import { color } from 'styles/colors'

type Props = {
  deviceId: string
  hasAwairDevice: boolean
  reportCache: object
  onNoZones?: () => void
}

const DashboardStatus = ({ deviceId, hasAwairDevice, reportCache, onNoZones }: Props) => {
  const { eventData: report } = useNexiaStream(deviceId, 'current_status', reportCache)

  useEffect(() => {
    if (report && onNoZones && (!report.zones || report.zones.length <= 1)) {
      onNoZones()
    }
  }, [report, onNoZones])

  if (!report) {
    return (
      <S.Panel>
        <Panel.Header>
          <Panel.Title>Status</Panel.Title>
        </Panel.Header>
        <S.NoData><h1>No Data Received Yet</h1></S.NoData>
      </S.Panel>
    )
  }

  if (!report.zones || report.zones.length === 0) {
    return null
  }

  return (
    <S.Panel>
      <Panel.Header pingdomId="thermostat-current-status-container">
        <Panel.Title>Status<S.ConnectedStatusIcon isConnected={report.connected} size="14" /> </Panel.Title>
        <LastUpdated date={report.lastUpdatedAt} />
      </Panel.Header>
      <Status report={report} hasZones={report.zones.length > 1} />
      {
        !_.isEmpty(report.zones) &&
        report.zones.length === 1 &&
        <ThermostatBox {...report.zones[0]} mode={report.systemMode} outdoorTemperature={report.outdoorTemperature} hasAwairDevice={hasAwairDevice} />
      }
      {
        report.zones.length > 1 &&
          <S.ZoneHeader>
            <Panel.Title>Zones</Panel.Title>
            <LastUpdated date={report.lastUpdatedAt} />
          </S.ZoneHeader>
      }
      {
        report.zones.length > 1 && (report.zones.map((zone, index) => {
          return (
            <ZoneBox key={`zonebox-${zone.zoneId || index}`} {...zone} mode={zone.reqZoneMode} hasAwairDevice={hasAwairDevice} />
          )
        }))
      }
    </S.Panel>
  )
}

export default DashboardStatus

const S = {
  Panel: styled(Panel)`
    background-color: ${color('paneBackground')};
    border-bottom: 0px;
    padding: 0px;
    width: calc(100% - 0px);
  `,
  NoData: styled(NoData)`
    h1 {
      font-size: 28px;
    }
  `,
  ConnectedStatusIcon: styled(ConnectedStatusIcon)`
    width: 16px;
    height: 16px;
  `,
  ZoneHeader: styled(Panel.Header)`
    border-top: 1px solid ${color('border')};
    border-radius: 0px;
    padding-top: 10px;
    margin-top: 15px;
  `
}
